<template>
  <ui-component-modal
    :modalTitle="$t('Components.Terms.ModalActivateTerm.Main_Title')"
    :isSaving="isActivating"
    :isSavingSuccess="isActivateSuccess"
    :isSavingError="isActivateError"
    :hideFooterButtons="isActivateError || isActivateSuccess"
    :disableSaveButton="!isActivateConfirmed || isActivating"
    :onClickCancel="onClickCancel"
    :onClickSave="activateTerm"
    :showModal="showModal"
    @closeModal="onClickCancel"
  >
    <template slot="modalTitle"></template>
    <template v-slot:content>
      <div class="has-margin-bottom is-size-5 has-text-centered">
        {{ $t('Components.Terms.ModalActivateTerm.Message_Warning') }}
      </div>
      <div class="has-text-centered">
        <BaseCheckbox
          v-model="isActivateConfirmed"
          class="has-text-left"
          :label="$t('Components.Terms.ModalActivateTerm.Text_YesImSure')"
        />
      </div>
    </template>
  </ui-component-modal>
</template>

<script>
import Vue from 'vue'
import { mapState, mapMutations } from 'vuex'
import { EventBus } from '@/eventbus/event-bus'
import termsProvider from '@/providers/terms'

const BaseCheckbox = () => import('@/components/UI/Form/BaseCheckbox')

export default {
  components: {
    BaseCheckbox,
  },

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    onClickCancel: {
      type: Function,
      required: true,
    },

    term: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isActivateConfirmed: false,
      isActivating: false,
      isActivateSuccess: false,
      isActivateError: false,
    }
  },

  computed: {},

  created() {},

  methods: {
    activateTerm() {
      let self = this

      if (!self.isActivating) {
        self.isActivating = true

        termsProvider.methods
          .activateTerm(self.term.Id)
          .then((response) => {
            if (response.status === 200) {
              self.$emit('termActivated', response.data)

              self.onClickCancel()
            }
          })
          .catch((error) => {
            self.isActivateError = true
          })
          .finally(() => {
            self.isActivating = false
          })
      }
    },
  },
}
</script>
